import{a as e}from"./chunk-DI2XYJKC.js";import{a as c}from"./chunk-BLOFHQLU.js";import{e as t}from"./chunk-LTVAKA4D.js";import{m as o}from"./chunk-HBP5N4FR.js";o();c();function f(r){e.dispatch(t(r))}export{f as a};
//# sourceMappingURL=chunk-SIQ4OZHU.js.map
